import Team from "../interfaces/team";
import useApi from "./useApi";
import { useQuery } from "@tanstack/react-query";
import { TEAM_URL } from "../util/constants";



const useTeams = () => {
    const { recover } = useApi<Team[]>(`${TEAM_URL}/`);

    return useQuery({
        queryKey: ["teams"],
        queryFn: () => recover()
    });
}

export default useTeams;